
import Card from "@/Components/General/Card.vue";
import { computed, defineComponent } from "@vue/runtime-core";

export default defineComponent({
  props: {
    withCard: {
      type: Boolean,
      default: true,
    },
    dismissOnOutsideClick: {
      type: Boolean,
      default: () => true,
    },
  },
  emits: ["dismiss"],
  components: {
    Card,
  },
  setup(props, context) {
    const element = computed(() => {
      if (props.withCard) {
        return "Card";
      } else {
        return "div";
      }
    });

    const dismiss = () => {
      if (props.dismissOnOutsideClick) {
        context.emit("dismiss");
      }
    };

    return {
      dismiss,
      element,
    };
  },
});
